import { createContext, useEffect, useReducer } from "react";

import axios from "../utils/axios";
import AdminReducer from "../reducers/AdminReducer";
import { isValidToken, setSession } from "../utils/jwt";
import { AdminConstants } from "../constants/index";
import { saveFile } from "../utils/common";
const initialState = {
  admins: [],
  paging: {
    totalNumberOfRecords: 0,
    totalNumberOfPages: 0,
    pageNumber: 0,
    pageSize: 0,
  },
  hasError: false,
  errorMessage: "",
  adminSearchResults: [],
  admin: {},
  isUpload: false,
  uploadError: false,
  uploadSuccess: false,
  isSubmitting: false,
  isLoadingDownload: false,
  adminAutoSearchResults: {
    data: [],
    paging: {
      hasNextPage: false,
      hasPreviousPage: false,
      pageNumber: 0,
      pageSize: 0,
      totalNumberOfPages: 0,
      totalNumberOfRecords: 0,
    },
  },
  autoSearchLoading: false,
  isLoading: true,
  isLoadingAutoSearch: false,
  downloadFileType: "",
};
const initPayload = {
  filters: [],
  pagination: {
    pageNumber: 1,
    pageSize: 100,
  },
  sortFields: [],
};

const AdminContext = createContext({
  ...initialState,
  getAllAdmin: () => {},
  addAdmin: () => {},
  searchAdmin: () => {},
  autoSearchAdmin: () => {},
  getAdmin: () => {},
  updateAdmin: () => {},
  downloadFile: () => {},
  sampleFile: () => {},
  uploadFile: () => {},
});

function AdminProvider({ children }) {
  const [state, dispatch] = useReducer(AdminReducer, initialState);

  const getAllAdmin = async (payload) => {
    try {
      dispatch({
        type: AdminConstants.FETCH_ADMIN_REQUEST,
      });
      const response = await axios.post("/cpanel/admin/list", payload);
      dispatch({
        type: AdminConstants.FETCH_ADMIN_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } catch (exception) {
      dispatch({
        type: AdminConstants.FETCH_ADMIN_FAILURE,
      });
    }
  };
  const searchAdmin = async (payload) => {
    try {
      const response = await axios.post("/cpanel/admin/search", payload);
      dispatch({
        type: AdminConstants.ADMIN_SEARCH_REQUEST,
      });
      console.log(response.data, "response.data");
      dispatch({
        type: AdminConstants.ADMIN_SEARCH_SUCCESS,
        payload: response.data,
      });
    } catch (exception) {
      dispatch({
        type: AdminConstants.ADMIN_SEARCH_FAILURE,
      });
    }
  };
  const autoSearchAdmin = async (payload) => {
    try {
      const response = await axios.post("/cpanel/admin/auto-search", payload);
      dispatch({
        type: AdminConstants.ADMIN_AUTO_SEARCH_REQUEST,
      });
      console.log(response.data, "response.data");
      dispatch({
        type: AdminConstants.ADMIN_AUTO_SEARCH_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } catch (exception) {
      dispatch({
        type: AdminConstants.ADMIN_AUTO_SEARCH_FAILURE,
      });
    }
  };
  const addAdmin = async (payload) => {
    const response = await axios.post("/cpanel/admin/add", payload);
    dispatch({
      type: AdminConstants.ADD_ADMIN_REQUEST,
    });
    dispatch({
      type: AdminConstants.ADD_ADMIN_SUCCESS,
      payload: response.data,
    });
  };

  const getAdmin = async (id) => {
    const response = await axios.get("/cpanel/admin/" + id);
    dispatch({
      type: AdminConstants.GET_ADMIN_REQUEST,
    });
    dispatch({
      type: AdminConstants.GET_ADMIN_SUCCESS,
      payload: response.data,
    });
  };

  const updateAdmin = async (payload) => {
    const response = await axios.put("/cpanel/admin/update/" + payload.adminId, payload);
    dispatch({
      type: AdminConstants.UPDATE_ADMIN_REQUEST,
    });
    dispatch({
      type: AdminConstants.UPDATE_ADMIN_SUCCESS,
      payload: response.data,
    });
  };

  const downloadFile = async (fileType, payload) => {
    dispatch({
      type: AdminConstants.DOWNLOAD_ADMIN_REQUEST,
      payload: {
        fileType: fileType,
      },
    });
    const response = await axios.post("/cpanel/admin/export/" + fileType, payload, {
      responseType: "blob",
    });
    console.log(response.headers, "filename");
    //const filename = response.headers.get("content-disposition").split('"');

    await saveFile(response.data, "admin." + fileType);
    dispatch({
      type: AdminConstants.DOWNLOAD_ADMIN_SUCCESS,
      payload: response.data,
    });
  };

  const sampleFile = async (fileType) => {
    const response = await axios.get("/cpanel/admin/sample/" + fileType, {
      responseType: "blob",
    });

    await saveFile(response.data, "sample_admin." + fileType);
    dispatch({
      type: AdminConstants.DOWNLOAD_ADMIN_REQUEST,
    });
    dispatch({
      type: AdminConstants.DOWNLOAD_ADMIN_SUCCESS,
      payload: response.data,
    });
  };

  const uploadFile = async (payload) => {
    try {
      dispatch({
        type: AdminConstants.UPLOAD_ADMIN_REQUEST,
      });
      const response = await axios({
        url: "/cpanel/admin/upload",
        method: "POST",
        data: payload,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      dispatch({
        type: AdminConstants.UPLOAD_ADMIN_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      console.log("errr", error);
      dispatch({
        type: AdminConstants.UPLOAD_ADMIN_FAILURE,
      });
    }
  };

  return (
    <AdminContext.Provider
      value={{
        ...state,
        getAllAdmin,
        addAdmin,
        searchAdmin,
        autoSearchAdmin,
        getAdmin,
        updateAdmin,
        downloadFile,
        sampleFile,
        uploadFile,
      }}
    >
      {children}
    </AdminContext.Provider>
  );
}

export { AdminContext, AdminProvider };
